import moment from 'moment';

import { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';

import JobStatus from './JobStatus';
import JobUser from './JobUser';
import JobDate from './JobDate';
import JobMessage from './JobMessage';
import JobCounter from './JobCounter';
import JobCounterLink from './JobCounterLink';
import JobStopButton from './JobStopButton';
import JobProgress from './JobProgress';
import JobInfoButton from './JobInfoButton';

const JobCard = job => {
  const [displayDetails, setDisplayDetails] = useState(job.status === 'WORKING');
  const toggleDetails = () => setDisplayDetails(!displayDetails);

  const getJobTime = () => {
    if (!job.started_at) {
      return null;
    }

    const started_at = moment(job.started_at);
    const done_at = moment(job.done_at || undefined);

    const job_time_diff = done_at.diff(started_at);
    return moment.utc(job_time_diff).format('HH:mm:ss');
  };

  return (
    <div className={`card border-0 shadow-sm`} id={job.id}>
      <div className={`card-body`}>
        <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center clickable" onClick={toggleDetails}>
          <JobUser {...job} />
          <JobDate label="bots.jobs.card.columns.created_at" date={job.created_at} />
          <JobDate label="bots.jobs.card.columns.started_at" date={job.started_at} />
          <JobDate label="bots.jobs.card.columns.done_at" date={job.done_at} />
          <JobStatus {...job} />
          <JobProgress {...job} />
          <JobStopButton {...job} />

          <div className="d-none d-md-block">
            <FiChevronDown size={26} />
          </div>
        </div>

        <div className={displayDetails ? '' : 'd-none'}>
          <hr className="mb-0" />

          <div className="d-flex flex-column flex-md-row justify-content-between p-2">
            <JobCounterLink job={job} status="pending" />
            <JobCounterLink job={job} status="done" />
            <JobCounterLink job={job} status="not_done" />
            <JobCounterLink job={job} status="failed" />
            <JobCounter status="working" value={job.working_objects} />
            <JobCounter status="total" value={job.total_objects} />
            <JobCounter status="avg_time" value={moment(job.avg_time || '00:00:00', 'HH:mm:ss').format('HH:mm:ss')} />
            <JobCounter status="job_time" value={getJobTime()} hiddenNoValue />
          </div>

          <div>
            <JobMessage {...job} />
          </div>

          <div className="mt-4 text-center">
            <hr />
            <JobInfoButton {...job} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobCard;
